export const CTPayout = {
	LOTTO_DOUBLE_CHANGE: {
		title: 'DOUBLE CHANCE GAMES',
		slug: 'Double_chance_prize'
	},
	LOTTO_TURBO: {
		title: 'turbo',
		slug: 'LOTTO_TURBO'
	},
	LOTTO_CHANCE: {
		title: 'chance',
		slug: 'LOTTO_CHANCE'
	},
	LOTTO_CHANCE_PLUS: {
		title: 'chance+',
		slug: 'LOTTO_CHANCE_PLUS'
	}
}